import { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Hero from './views/Hero';
import CheckPermissions from './components/Permission/CheckPermissions';
import { RoomClient } from './lib/RoomClient';
import RoomClientContext from './lib/RoomClientContext';
import { useMessageHandler } from './hooks/useMessageHandler';
import { useReadyNotifier } from './hooks/useReadyNotifier';
import { useScenarioHandler } from './hooks/useScenarioHandler';
import { useUpdateParent } from './hooks/useUpdateParent';

const roomClient = new RoomClient();
const isChild = window.top !== window.self;
const background = isChild ? 'transparent' : '#1E5B53';

function App() {
  const [colorTheme, setColorTheme] = useState({
    typography: {
      fontFamily: [
        'Manrope',
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'Oxygen',
        'Ubuntu',
        'Cantarell',
        'Fira Sans',
        'Droid Sans',
        'Helvetica Neue',
        'sans-serif',
      ].join(','),
    },
    palette: {
      primary: {
        main: '#1E5B53',
        contrast: '#00D2BC',
      },
      secondary: {
        main: '#f5f5f5',
      },
      background: {
        default: background,
      },
      text: {
        primary: '#0e0c1d',
        secondary: '#f5f5f5',
      },
      success: {
        main: '#33B980',
      },
      error: {
        main: '#F9746A',
      },
      black: '#0e0c1d',
      grey: '#3E3E3E',
      white: '#f5f5f5',
    },
  });

  useMessageHandler(setColorTheme);
  useReadyNotifier();
  useScenarioHandler();
  useUpdateParent();

  return (
    <ThemeProvider theme={createTheme(colorTheme)}>
      <CssBaseline />
      <RoomClientContext.Provider value={roomClient}>
        <Router>
          <CheckPermissions>
            <Hero />
          </CheckPermissions>
        </Router>
      </RoomClientContext.Provider>
    </ThemeProvider>
  );
}

export default App;
